export default __webpack_public_path__ + "static/media/19.5g28mmn.1e9ba420.jpeg";